import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { localState, STATE_KEYS } from 'utils/local-storage';

type TConfigState = {
  useDarkTheme: boolean;
  menuOpen: boolean;
};

const DEFAULT_CONFIG: TConfigState = {
  useDarkTheme: false,
  menuOpen: false,
};

// Раньше initialState был `localState.get(...) || {}`, приведённый к
// TConfigState: на чистом localStorage поля были undefined, хотя тип обещал boolean.
const initialState: TConfigState = {
  ...DEFAULT_CONFIG,
  ...(localState.get<Partial<TConfigState>>(STATE_KEYS.CONFIG) || {}),
};

const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    setConfig(state, action: PayloadAction<Partial<TConfigState>>) {
      Object.assign(state, action.payload);
      localState.set(STATE_KEYS.CONFIG, { ...state });
    },
  },
});

export const { setConfig } = configSlice.actions;
export default configSlice;
